<template>
    <div class="slide">
        <img
            class="slide__image"
            aria-live="polite"
            :src="slideImage"
            :alt="imageAlt"
        >
        <div
            class="slide__title"
            aria-live="polite"
            v-html="title"
        />
        <div
            class="slide__description"
            aria-live="polite"
            v-html="description"
        />
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = withDefaults(defineProps<{
    title: string
    description: string
    imageName: string
    imageAlt?: string
}>(), {
    imageAlt: '',
})

const slideImage = computed(() => {
    return new URL(`../../assets/welcomeSeries/${props.imageName}`, import.meta.url).href
})

</script>

<style lang="scss" scoped>
.slide {
    text-align: center;

    &__image {
        padding: 45px 0 21px;
        box-sizing: border-box;
        max-width: 436px;
        width: 100%;
        display: block;
        margin: 0 auto;

        @include breakpoint(black-bear) {
            padding: 17px 0 29px;
        }
    }

    &__title {
        font-size: 15px;
        line-height: 20px;
        font-weight: 600;
        max-width: 340px;
        margin: 0 auto 8px;

        @include breakpoint(black-bear) {
            max-width: 239px;
        }
    }

    &__description {
        font-size: 14px;
        line-height: 19px;
        max-width: 340px;
        margin: 0 auto;
        color: $slate-03;

        @include breakpoint(black-bear) {
            max-width: 310px;
        }
    }
}
</style>
